import { jwtDecode } from "jwt-decode";

const listeners = new Set();
function addEventListener(listener) {
    listeners.add(listener);
}

function removeEventListener(listener) {
    listeners.delete(listener);
}

// listen to local storage events, and trigger if we see the JWT token change
// this is needed if multiple tabs are open
window.addEventListener('storage', event => {
    if (event?.key === null || event?.key === 'token.jwt') {
        listeners.forEach(l => l({}));
    }
});

function jwtset(token) {
    if (token) {
        localStorage.setItem('token.jwt', token);
    } else {
        localStorage.removeItem('token.jwt');
    }

    // storage listener only triggers for other tabs
    // so notify listeners of login change here
    listeners.forEach(l => l({}));
}

function jwtget() {
    return localStorage.getItem('token.jwt');
}

function jwtdecode() {
    try {
        const token = localStorage.getItem('token.jwt');
        return jwtDecode(token);
    } catch (e) {
        // missing or invalid key
        return {};
    }
}

// determines if the currently logged user is a contributor
function contributor() {
    return jwtdecode()?.contributor === 1;
}

// determines if the currently logged user is a patreon/twitch supporter
function supporter() {
    return jwtdecode()?.supporter === 1;
}

// determines if the currently logged user was a previous twitch supporter
function previous() {
    return jwtdecode()?.previous === 1;
}

// account for currently logged in user's characters (i.e. not login ID)
function account() {
    return jwtdecode()?.account;
}

const login = {
    jwt: {
        set: jwtset,
        get: jwtget
    },
    addEventListener,
    removeEventListener,
    contributor,
    supporter,
    previous,
    account
};
export default login;